"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useI18n = useI18n;
const tslib_1 = require("tslib");
const webapi_1 = require("@fegobull/webapi");
const en_us_1 = tslib_1.__importDefault(require("./en-us"));
const ja_1 = tslib_1.__importDefault(require("./ja"));
const zh_cn_1 = tslib_1.__importDefault(require("./zh-cn"));
const zh_hk_1 = tslib_1.__importDefault(require("./zh-hk"));
const { useI18n: _useI18n } = webapi_1.use;
const DEFAULT_LANG = 1;
const LangData = {
    1: zh_hk_1.default,
    2: en_us_1.default,
    0: zh_cn_1.default,
    5: ja_1.default
};
const $t = _useI18n(LangData);
function trans(path, valueMap = {}) {
    const result = $t(path, DEFAULT_LANG);
    if (typeof result !== 'string') {
        return result;
    }
    return result.replace(/\{(\w+)\}/g, (match, key) => {
        return valueMap[key] === void 0 ? match : valueMap[key]; // eslint-disable-line @typescript-eslint/no-unnecessary-condition
    });
}
function useI18n() {
    return trans;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJpbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQXVCQSwwQkFFQzs7QUF6QkQsNkNBQXVDO0FBQ3ZDLDREQUEyQjtBQUMzQixzREFBc0I7QUFDdEIsNERBQTJCO0FBQzNCLDREQUEyQjtBQUMzQixNQUFNLEVBQUUsT0FBTyxFQUFFLFFBQVEsRUFBRSxHQUFHLFlBQUcsQ0FBQztBQUNsQyxNQUFNLFlBQVksR0FBRyxDQUFDLENBQUM7QUFDdkIsTUFBTSxRQUFRLEdBQUc7SUFDYixDQUFDLEVBQUUsZUFBSTtJQUNQLENBQUMsRUFBRSxlQUFJO0lBQ1AsQ0FBQyxFQUFFLGVBQUk7SUFDUCxDQUFDLEVBQUUsWUFBRTtDQUNSLENBQUM7QUFDRixNQUFNLEVBQUUsR0FBRyxRQUFRLENBQUMsUUFBUSxDQUFDLENBQUM7QUFDOUIsU0FBUyxLQUFLLENBQUMsSUFBWSxFQUFFLFdBQW1DLEVBQUU7SUFDOUQsTUFBTSxNQUFNLEdBQUcsRUFBRSxDQUFDLElBQUksRUFBRSxZQUFZLENBQUMsQ0FBQztJQUN0QyxJQUFJLE9BQU8sTUFBTSxLQUFLLFFBQVEsRUFBRSxDQUFDO1FBQzdCLE9BQU8sTUFBTSxDQUFDO0lBQ2xCLENBQUM7SUFDRCxPQUFPLE1BQU0sQ0FBQyxPQUFPLENBQUMsWUFBWSxFQUFFLENBQUMsS0FBSyxFQUFFLEdBQUcsRUFBRSxFQUFFO1FBQy9DLE9BQU8sUUFBUSxDQUFDLEdBQUcsQ0FBQyxLQUFLLEtBQUssQ0FBQyxDQUFDLENBQUMsQ0FBQyxLQUFLLENBQUMsQ0FBQyxDQUFDLFFBQVEsQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDLGtFQUFrRTtJQUMvSCxDQUFDLENBQUMsQ0FBQztBQUNQLENBQUM7QUFDRCxTQUFnQixPQUFPO0lBQ25CLE9BQU8sS0FBSyxDQUFDO0FBQ2pCLENBQUMifQ==